import { render, staticRenderFns } from "./StoreCardSkeleton.vue?vue&type=template&id=5acdecd0&scoped=true&"
import script from "./StoreCardSkeleton.vue?vue&type=script&lang=ts&"
export * from "./StoreCardSkeleton.vue?vue&type=script&lang=ts&"
import style0 from "./StoreCardSkeleton.vue?vue&type=style&index=0&id=5acdecd0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5acdecd0",
  null
  
)

export default component.exports